import {Component, OnInit} from '@angular/core';
import {MetaTitle} from '../../../../decorator/meta-title';
import {OfferService} from '../../../../services/offer/offer.service';
import {Offer} from '../../../../models/offer';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {CurrencyPipe} from '../../../../pipes/currency/currency.pipe';
import {PartnerOffer} from '../../../../models/partner-offer';
import {PartnerOfferService} from '../../../../services/partner-offer/partner-offer.service';
import {AuthService} from '../../../../services/auth/auth.service';
import {Partner} from '../../../../models/partner';
import {ImageService} from '../../../../services/image/image.service';
import {ActivatedRoute} from '@angular/router';
import {SnackbarService} from '../../../../services/snackbar/snackbar.service';
import {LoaderService} from '../../../../services/loader/loader.service';
import {forkJoin} from 'rxjs';
import {ConstantList} from '../../../../models/constant-list';

@Component({
  selector: 'app-offer-view',
  imports: [
    NgForOf,
    TranslatePipe,
    CurrencyPipe,
    NgClass,
    NgIf
  ],
  templateUrl: './offer-view.component.html',
  styleUrl: './offer-view.component.scss'
})
@MetaTitle('Offer')
export class OfferViewComponent implements OnInit {

  connectedUser: Partner | null = null;
  offer: Offer | null = null;
  partnerOffers: PartnerOffer[] = [];
  verticalList: ConstantList[] = [];
  loading: boolean = true;
  applying: boolean = false;

  constructor(
    protected imageService: ImageService,
    private auth: AuthService,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private offerService: OfferService,
    private partnerOfferService: PartnerOfferService,
  ) {
  }

  ngOnInit(): void {
    this.loader.startLoading();

    forkJoin([
      this.auth.getConnectedUser(),
      this.auth.getAsyncConfig(),
    ]).subscribe(([connectedUser, config]) => {
      if (connectedUser && connectedUser.id) {
        this.connectedUser = connectedUser;
        this.verticalList = config?.data?.verticalList.map((vertical: any) => new ConstantList().deserialize(vertical));

        this.partnerOfferService.findAll().subscribe((partnerOffers: PartnerOffer[]) => {
          this.partnerOffers = partnerOffers;

          const id = Number(this.route.snapshot.paramMap.get('id'));
          this.offerService.findOneById(id, {groups: 'product,goals,goal,goalTypes,goalType'}).subscribe((offer: Offer) => {
            this.offer = offer;

            this.loading = false;
            this.loader.stopLoading();
          });
        });
      }
    });
  }

  getVerticalName(verticalId: number): string {
    const vertical = this.verticalList.find((vertical: ConstantList) => Number(vertical.id) === Number(verticalId));

    return 'vertical.' + (vertical?.identifier ?? '');
  }

  applyOffer(): void {
    if (!this.offer?.id) {
      return;
    }
    if (this.applying) {
      return;
    }
    this.applying = true;

    this.partnerOfferService.create({offerId: this.offer.id}).subscribe(() => {
      this.partnerOfferService.findAll().subscribe((partnerOffers: PartnerOffer[]) => {
        this.partnerOffers = partnerOffers;

        this.snackbar.success('Your application to this offer is pending.');

        this.applying = false;
      });
    });
  }

  getOfferStatus(): string {
    const offer = this.offer;
    if (!offer) {
      return '';
    }

    const partnerOffer = this.partnerOffers.find((data: PartnerOffer) => data.offer?.id === offer.id);
    if (partnerOffer) {
      return partnerOffer.status;
    }

    return offer.requireApproval && !this.connectedUser?.allOffersAccess ? 'apply_to_run' : 'public';
  }

  getOfferStatusClass(): string {
    const status = this.getOfferStatus();

    switch (status) {
      case 'pending':
        return 'bg-warning';
      case 'apply_to_run':
        return 'bg-primary';
      case 'active':
        return 'bg-success';
      default:
        return 'bg-dark';
    }
  }

}
